import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, CircularProgress } from 'material-ui';
import classNames from 'classnames';
import currencyFormatter from 'currency-formatter';
import HotelCategoryRender from './../../components/Reservation/HotelCategoryRender';
import { isValidImage } from '../Utils/shared';
import logoSource from '../../assets/hotel.svg';

const styles = theme => ({
    tinyhotelcard: {
        backgroundColor: '#FFFFFF',
        boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)',
        width: 380,
        maxWidth: 380,
        minHeigth: 124,
        padding: 4,
        zIndex: 1000,
        position: 'absolute',
        float: 'left'
    },

    image: {
        width: 100,
        height: 120,
        border: '1px solid grey',
        float: 'left',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        transition: 'background - image 1s ease-in -out',
        backgroundPosition: 'center center'
    },
    hotel: {
        paddingLeft: 110,
    },

    name: {
        fontSize: 16,
        paddingTop: 2,
        color: 'var(--primary-color)',
        fontWeight: 'bold',
        marginRight: 4
    },

    town: {
        fontSize: 10,
        color: 'var(--primary-color)',
        textAlign: 'left'
    },

    onrequest: {
        textAlign: 'left',
        float: 'left',
        color: 'var(--primary-color)',
    },
    priceleyend: {
        textAlign: 'right'
    },

    number: {
        fontWeight: 400,
        fontSize: 24
    },

    pvpLabel: {
        display: 'block',
        fontSize: 11,
        fontWeight: 600,
        color: '#555',
        textTransform: 'uppercase',
        letterSpacing: '0.03em',
        marginTop: 2
    }
});

class ResultMapPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            top: 100,
            left: 100,
            elementHeight: 0,
            elementWidth: 0,
            offsetTop: 0,
            defaultImage: logoSource,
            validImage: false
        };
    }

    componentDidMount() {
        this.setupListener();
        if (this.divElement) {
            const height = this.divElement.clientHeight;
            this.setState({
                elementWidth: this.divElement.clientWidth,
                elementHeight: height, offsetTop: this.divElement.offsetTop
            });
        }
        // if (this.props.hotel && this.props.hotel.defaultImage) {
        //     this.validateImage();
        // }
    }

    async UNSAFE_componentWillReceiveProps(newProps) {
        if (this.divElement) {
            const height = this.divElement.clientHeight;
            this.setState({
                elementWidth: this.divElement.clientWidth,
                elementHeight: height, offsetTop: this.divElement.offsetTop
            });
        }
        if (newProps && newProps.hotel) {
            this.setState({ loading: true });
            this.validateImage(newProps);
        } else {
            await this.setState({ loading: false, validImage: false, defaultImage: logoSource });
        }
    }

    componentWillUnmount() {
        this.removeListener();
    }

    validateImage(props) {
        isValidImage(props.hotel.defaultImage).then(valid => {
            if (valid && props.hotel) {
                this.setState({ loading: false, validImage: true, defaultImage: props.hotel.defaultImage });
            } else {
                this.setState({ loading: false, validImage: false, defaultImage: logoSource });
            }
        });
    }

    setupListener() {
        const scope = this;
        let element = document.getElementById('resultMapDivContainer');
        this.boundary = element;
        element.addEventListener('mousemove', function (e) {
            scope.handleMouseMove(e);
        }, false);
    }

    removeListener() {
        const scope = this;
        let element = document.getElementById('resultMapDivContainer');
        this.boundary = null;
        element.removeEventListener('mousemove', function (e) {
            scope.handleMouseMove(e);
        }, false);
    }

    handleMouseMove(e) {
        if (e) {
            e.preventDefault();
            let mousseoffset = 10;
            let xpos = e.pageX;
            let ypos = e.pageY;
            if (xpos - this.boundary.offsetLeft - mousseoffset + this.state.elementWidth > this.boundary.clientWidth) {
                xpos = xpos - this.state.elementWidth - 20;
            }
            if (ypos - this.boundary.offsetTop - mousseoffset + this.state.elementHeight > this.boundary.clientHeight) {
                ypos = ypos - this.state.elementHeight - 20;
            }
            /*
            var element1 = this.state.offsetTop + this.state.elementHeight + 20;
            if (ypos > element1) {
                ypos = ypos + this.state.elementHeight + 20;
            }*/
            this.setState({
                top: ypos,
                left: xpos
            });

        }
    }

    formatPrice(value) {
        return currencyFormatter.format(value, { code: 'EUR' });
    }

    render() {
        const { classes, hotel, nights, t, showPVP } = this.props;
        return (hotel ? <div
            className={classes.tinyhotelcard + ' popup-map'}
            ref={(divElement) => this.divElement = divElement}
            style={{ top: this.state.top, left: this.state.left }}>
            {this.state.loading ?
                <div className={classes.image} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                    <CircularProgress className="cmsProgressBar" />
                </div> :
                <div className={classes.image}
                    style={{ backgroundImage: ' url("' + this.state.defaultImage + '")' }}>
                </div>
            }
            <div className={classes.hotel}>
                <span className={classes.name}>{hotel.name}</span><br />
                <span><HotelCategoryRender category={hotel ? hotel.category : null} /></span><br />
                <p className={classes.town}>{hotel.town.townName}</p>
                <div style={{ minHeight: 40, marginTop: 4 }}>
                    {hotel && hotel.totalOffers && hotel.totalOffers.length > 0 ?
                        <small className="Offer">{t('RESULT_CARD.OFFER')}</small> : ''}
                    {hotel && hotel.totalOffers && hotel.totalOffers.length &&
                        hotel.totalOffers.map((item, idx, src) => {
                            return <small>{item.type}{idx !== src.length - 1 ? ', ' : ''}</small>;
                        })}
                </div>
                <div className={classes.onrequest}>
                    <small><b>{hotel.onrequest ? t('COMMON.ON_REQUEST') : ''}</b></small>
                </div>
                <div className={classNames(classes.priceleyend, classes.number)}>
                    <span>{showPVP ?
                        this.formatPrice(hotel.minTotalRetailPrice) : this.formatPrice(hotel.minTotalPrice)}</span>
                    {!showPVP && hotel.minTotalRetailPrice && !isNaN(hotel.minTotalRetailPrice)
                        && Number(hotel.minTotalRetailPrice) !== 0
                        && Number(hotel.minTotalRetailPrice) !== Number(hotel.minTotalPrice) ?
                        <small className={classes.pvpLabel}>PVP: {this.formatPrice(hotel.minTotalRetailPrice)}</small>
                        : null}
                </div>
                <div className={classes.priceleyend}>
                    <small>{t('RESULT_CARD.PRICE_BY_NIGTH', { count: nights.nights })}</small>
                </div>
            </div>
        </div> : ''
        );
    }
}

ResultMapPopUp.defaultProps = {
    onClick: null,
};

ResultMapPopUp.propTypes = {
    onClick: PropTypes.func,
    text: PropTypes.string.isRequired,
};

export default withStyles(styles)(ResultMapPopUp);


// WEBPACK FOOTER //
// ./src/components/Results/ResultMapPopUp.js